export default __webpack_public_path__ + "static/media/heartFinger.1768ba6a.svg";